import { render, staticRenderFns } from "./OrganizationAccountManagement.vue?vue&type=template&id=0f72f162&"
import script from "./OrganizationAccountManagement.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAccountManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QPageContainer});
